module.exports = __webpack_public_path__ + "img/icon_validate_white.1a3797e0.svg";